import { isValidObject, objectToQueryString } from '../helpers/functions';

export const storeFront = {
  forVendor: {
    de: () => '/gastronomien',
    en: () => '/for-vendor',
  },
  forHotels: {
    de: () => '/hotels',
    en: () => '/hotels',
  },
  forCompany: {
    de: () => '/unternehmen',
    en: () => '/unternehmen',
  },
  partnerGastronomien: {
    de: () => '/partner-gastronomien',
    en: () => '/partner-gastronomien',
  },
  register: {
    de: () => '/registrieren',
    en: () => '/register',
  },
  login: {
    en: () => '/login',
  },
  checkout: {
    de: () => '/kasse',
    en: () => '/kasse',
  },
  restaurants: {
    de: () => '/shops',
    en: () => '/shops',
  },
  events: {
    de: () => 'veranstaltungen',
    en: () => 'veranstaltungen',
  },
  registerBusiness: {
    de: (params = {}) => {
      const pathname = '/restaurant-registrieren';
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
    en: (params = {}) => {
      const pathname = '/restaurant-registrieren';
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
  },
  loginBusiness: {
    de: () => '/unternehmen/login',
  },
  forgotPassword: {
    de: () => '/passwort-vergessen',
  },
  restaurantForgotPassword: {
    de: () => '/unternehmen/passwort-vergessen',
  },
  orderConfirm: {
    de: () => '/order-confirm',
  },
};

export const restaurant = {
  login: {
    de: () => '/unternehmen/login',
  },
  dashboard: {
    de: () => '/business/dash',
  },
  subscriptions: {
    de: (params = {}) => {
      const pathname = `/business/dash/subscriptions`;
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
    en: (params = {}) => {
      const pathname = `/business/dash/subscriptions`;
      return isValidObject(params)
        ? pathname + objectToQueryString(params)
        : pathname;
    },
  },
  welcome: {
    en: () => '/restaurant-welcome',
  },
};
